// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "../js/turbo_hack.js";
import "channels";
Rails.start();
ActiveStorage.start();
window.Rails = Rails;
import jquery from "jquery";
window.$ = window.jquery = jquery;

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import "@fortawesome/fontawesome-free/css/all";
require("trix");
require("@rails/actiontext");
import "controllers";
import "select2";

document.addEventListener("turbo:load", function () {
  if ($("form")[0]) $("form")[0].reset();
  let elem = $(".form-submit");
  if ($(".form-submit")[0]) {
    Rails.enableElement($(".form-submit")[0]);
    elem.html(elem.data("originalMsg"));
  }

  // Handle mileage history loading (copied from application.js)
  document.querySelectorAll('[data-mileage-history]').forEach(container => {
    const vinNumber = container.dataset.vin;
    const searchId = container.dataset.searchId;
    
    // Check if we already have mileage history loaded
    const existingHistory = container.querySelector('.mileage-history-data');
    if (!existingHistory && vinNumber) {
      const url = `/license_plate_data?search[vin_numbers][]=${vinNumber}&search_id=${searchId}&vin_number=${vinNumber}`;
      Turbo.visit(url, { frame: container.id });
    }
  });

  // Initialize mileage history section
  const mileageHistorySection = document.querySelector('[data-mileage-history-target]');
  if (mileageHistorySection) {
    mileageHistorySection.addEventListener('turbo:before-stream-render', (event) => {
      const targetElement = event.target;
      targetElement.classList.add('updating');
    });

    mileageHistorySection.addEventListener('turbo:stream-render', (event) => {
      const targetElement = event.target;
      targetElement.classList.remove('updating');
    });
  }

  // Initialize all tooltips
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      html: true
    });
  });
});

// Smart cleanup: Only clean up when leaving app OR going to pages that don't need streams
document.addEventListener("turbo:before-visit", function(event) {
  const url = event.detail.url;
  const currentHost = window.location.host;
  const isExternalUrl = !url.includes(currentHost) && (url.startsWith('http://') || url.startsWith('https://'));
  
  // Always cleanup on external navigation
  if (isExternalUrl) {
    console.log("Cleaning up turbo subscriptions for external navigation");
    cleanupSubscriptions();
    return;
  }
  
  // Check if destination page needs turbo streams
  const isGoingToResultsPage = url.match(/\/(decode|vin_compare)\/[^\/]+$/) || // results pages
                               url.match(/\/searches\/\d+/) ||                // search show pages  
                               url.includes('old_view');                       // old view pages
  
  const currentlyHasStreams = document.querySelectorAll("turbo-cable-stream-source").length > 0;
  
  // Clean up if we have streams but going to a page that doesn't need them
  if (currentlyHasStreams && !isGoingToResultsPage) {
    console.log("Cleaning up turbo subscriptions - going to page that doesn't need them");
    cleanupSubscriptions();
  }
  
  // Clear polling timeouts on any navigation
  if (window.searchPollingTimeout) {
    clearTimeout(window.searchPollingTimeout);
    window.searchPollingTimeout = null;
  }
});

function cleanupSubscriptions() {
  const streamSources = document.querySelectorAll("turbo-cable-stream-source");
  streamSources.forEach(source => {
    if (source.subscription) {
      source.subscription.unsubscribe();
      source.subscription = null;
    }
  });
}

window.addEventListener("DOMContentLoaded", () => {
  $(".select2").select2({
    width: "resolve",
  });
});
